<cx-searchbox [orderHistorySearch]='true' [searchValueClear]="clearSearchValue" (selectedProductEvent)="onProductSelected($event)" [config]='QUICKORDER_SEARCH_BOX_CONFIG'></cx-searchbox>
